<template>
<div class="chapter">
<div class="inner_page">
<p class="crt"><b><i>These Are My People: The Merle Kilgore Story</i></b></p>
<p class="crt1">© 2016 Mark Rickert. All rights reserved.</p>
<p class="crt2">No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.</p>
<p class="crt2">Published in the United States by WriteLife Publishing</p>
<p class="crt1">(An imprint of Boutique of Quality Books Publishing Company)</p>
<p class="crt1"><a href="http://www.writelife.com" id="A38" target="_blank">www.writelife.com</a></p>
<p class="crt2">978-1-60808-172-1 (p)</p>
<p class="crt1">978-1-60808-173-8 (e)</p>
<p class="crt2">Library of Congress Control Number: 2016947894</p>
<p class="crt2">Book design by Robin Krauss, <a href="http://bookformatters.com" id="A6I" target="_blank">bookformatters.com</a></p>
<p class="crt1">Cover design by Ellis Dixon, <a href="http://ellisdixon.com" id="ADC" target="_blank">ellisdixon.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?701a43db